__turbopack_context__.v({
  "paragraph-content": "NsJpgG_paragraph-content",
  "wrap-container": "NsJpgG_wrap-container",
  "wrap-content": "NsJpgG_wrap-content",
});
